//  🔥 Be careful do not format this file.
// Formatting might add parantesis that will lead to errors in the formula results 🔥

export const Jformula = (Z: number, field6: number, t: number): number => {
  const J = (Z * Number(field6) * t) / 8760.0;
  return J;
};

export const Mformula = (Z: number, field6: number, t: number, J: number): number => {
  const M = ((Z * Number(field6) * t) / 8760.0 - J) * 12;
  return M;
};

export const Wformula = (Z: number, field6: number, t: number, J: number, M: number): number => {
  const W = (((Z * Number(field6) * t) / 8760 - J) * 12 - M) * 4.33;
  return W;
};

export const Tformula = (Z: number, field6: number, t: number, J: number, M: number, W: number): number => {
  const T = ((((Z * Number(field6) * t) / 8760.0 - J) * 12 - M) * 4.33 - W) * 7;
  return T;
};

export const Kformula = (field6: number, t: number, field1: number, C: number): number => {
  const K = field1 * field6 * t * C;
  return K;
};

export const Sformula = (
  field1: number,
  field6: number,
  field4a: number,
  field4b: number,
  field3: number,
  t: number
): number => {
  const S2 = field1 * field6 * t * (((field4b * 15) / 100) * 0.75 + (field3 / 100) * field4a);

  return Number(S2.toFixed(2));
};

export const Sformula1 = (field1: number, field6: number, field4a: number, field3: number, t: number): number => {
  const S1 = (field1 * field6 * t * field4a * field3) / 100;

  return Number(S1.toFixed(2));
};

export const Sformula2 = (field1: number, field6: number, field4b: number, t: number): number => {
  const S2 = (field1 * field6 * t * field4b * 15) / 100;

  return Number(S2.toFixed(2));
};
